import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'

function errorIncludes (error: Error | any, needle: string): boolean {
  return ((error || '').message || '').includes(needle) || (error.stack || '').includes(needle)
}

export function bootBugsnag (Vue) {
  (window as any).bugsnagClient = Bugsnag.start({
    apiKey: process.env.VUE_APP_BUGSNAG_API_KEY || 'API_KEY',
    plugins: [new BugsnagPluginVue(Vue)],
    enabledReleaseStages: ['production', 'staging'],
    releaseStage: process.env.VUE_APP_ENV,
    collectUserIp: false,
    onError (report) {
      if (!report.originalError) return true

      const message = report.originalError.message || ''

      return !(
        message.includes('This video will be available for viewing shortly.')
        || message.includes('ResizeObserver loop completed with undelivered notifications')
        || errorIncludes(report.originalError, 'embed.tawk.to')
      )
    }
  })
}
